import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { problems } from '../../data/problems';
export function Problems() {
  return <section aria-labelledby="problems-title" className="bg-mint py-20 text-ink lg:py-24" data-id="element-557" data-mp="1d066xfzurfk6">
      <div className="mx-auto max-w-page px-5 lg:px-8" data-id="element-558" data-mp="1hyzj953el0ir">
        <SectionHeading id="problems-title" eyebrow="Sound familiar?" lead="Teaching flag football is fun." highlight="Planning it from scratch isn’t." data-id="element-559" data-mp="1hyhhxu1vvw3z" />

        <ul className="mt-12 grid gap-4 md:grid-cols-2 md:gap-5" data-id="element-560" data-mp="pau36vnanzp9">
          {problems.map(problem => <li key={problem.title} className="flex gap-4 rounded-xl border border-line bg-paperwhite p-6 sm:p-7" data-id="element-561" data-mp="u83ygrxd75l0">
              <span aria-hidden="true" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-2 border-alert text-alert" data-id="element-562" data-mp="z1yg7ptetahg">
                <XIcon className="h-5 w-5" strokeWidth={2.75} data-id="element-563" data-mp="6hhp8xbmjf9f" />
              </span>
              <div data-id="element-564" data-mp="66h63rgu0eqi">
                <h3 className="font-display text-[24px] font-bold uppercase leading-tight" data-id="element-565" data-mp="185t57v8po42">{problem.title}</h3>
                <p className="mt-2 text-base leading-relaxed text-body" data-id="element-566" data-mp="3smjx94s97mu0">{problem.text}</p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[30px] font-bold uppercase leading-[1.05] text-gold-dark sm:text-[40px]" data-id="element-567" data-mp="3nn7byoh16ntj">
          What if your whole school year of flag football was already planned?
        </p>
      </div>
    </section>;
}